import React from 'react';
import { Box, Typography, Paper, Container, Fade, CircularProgress } from '@mui/material';
import logo from '../../../assets/images/logo512x512-apple-touch.png';

/**
 * Pantalla de carga para trámites SAT
 * Muestra indicador de progreso y mensaje opcional
 *
 * @param {Object} props
 * @param {string} props.message - Mensaje de carga opcional
 */
const LoadingScreen = ({ message = 'Cargando datos del trámite...' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        overflow: 'auto',
      }}
    >
      <Container maxWidth='sm'>
        <Fade in={true} timeout={800}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              borderRadius: 4,
              bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Logo */}
            <Box sx={{ mb: 6, height: 100 }}>
              <img src={logo} alt='IOSPER Logo' style={{ height: '100%', objectFit: 'contain' }} />
            </Box>

            {/* Icono de Error */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                mb: 2,
              }}
            >
              {/* <Zoom in={true} timeout={1000}>
                            <ErrorOutlineIcon sx={{ fontSize: 50, color: 'error.main' }} />
                          </Zoom> */}
              <Typography
                variant='h4'
                component='h1'
                fontWeight='700'
                sx={{ color: 'text.primary' }}
              >
                Código leido correctamente
              </Typography>
            </Box>

            {/* Indicador de Carga */}
            <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={60} thickness={4} color='primary' />
            </Box>

            {/* Mensaje */}
            <Typography variant='body2' color='text.secondary' sx={{ mb: 4 }} fontSize={'1.125rem'}>
              {message}
            </Typography>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default LoadingScreen;
